<div class="wrapper">   
    <div class="self-justify-centre">
        <span class="text1">{{rainfallChance ? rainfallChance : '&nbsp;'}}</span>
        <!-- <span class="text1">{{rainfallChance | percent:'1.0-1':'en-AU' }}</span> -->
    </div>  
    <div class="self-justify-centre">
        <span class="text2">{{rainfallAmount ? rainfallAmount : '&nbsp;'}}</span>
    </div>    
</div>